<template>
  <v-card class="custom-text">
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('message.fileSharing.header') }}</v-toolbar-title>
    </v-toolbar>
    <p v-if="!thereAreFiles" class="no-files">
      {{ $t('message.fileSharing.thereAreNoFiles') }}
    </p>
    <v-list v-if="thereAreFiles">
      <v-list-item v-for="file in files" :key="file.uuid">
        <v-list-item-icon v-if="!file.sent"
          ><v-icon color="blue">mdi-download</v-icon>
        </v-list-item-icon>
        <v-list-item-icon v-if="file.sent"
          ><v-icon color="red">mdi-upload</v-icon>
        </v-list-item-icon>
        <v-list-item-content v-if="!file.sent">
          <a :href="file.url" class="download-button" :download="file.title">{{
            file.title
          }}</a>
        </v-list-item-content>
        <v-list-item-content v-if="file.sent">
          {{ file.title }}
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div id="upload-button">
      <v-btn
        color="red"
        fab
        large
        dark
        bottom
        right
        :loading="isSending"
        @click="onButtonClick"
      >
        <v-icon>mdi-upload</v-icon>
      </v-btn>
      <input
        ref="uploader"
        class="d-none"
        type="file"
        @change="onFileChanged"
        @click="onDialogOpen"
      />
    </div>
  </v-card>
</template>

<script>
import { fileSizeLimit } from '@/config/index.js';
import { v4 as uuidv4 } from 'uuid';

export default {
  data: () => ({
    selectedFile: null,
    isSending: false
  }),
  props: {
    files: { type: Array },
    sendFile: { type: Function },
    closeDialog: { type: Function },
    showMessage: { type: Function }
  },
  computed: {
    thereAreFiles: function() {
      return this.files.length != 0;
    }
  },
  methods: {
    onButtonClick() {
      window.addEventListener('focus', () => {}, { once: true });

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      if (this.selectedFile) {
        if (this.selectedFile.size > fileSizeLimit) {
          this.showMessage(
            this.$t('message.fileSharing.fileTooLarge', {
              fileSizeLimit: fileSizeLimit / 1024 / 1024
            })
          );
        } else {
          this.isSending = true;
          this.sendFile(this.selectedFile);
          this.isSending = false;
          const uuid = uuidv4();
          this.files.push({
            uuid: uuid,
            title: this.selectedFile.name,
            url: null,
            sent: true
          });
          this.selectedFile = null;
        }
      }
    },
    onDialogOpen(e) {
      e.target.value = null;
    }
  }
};
</script>

<style>
#upload-button {
  position: absolute;
  right: 10px;
  bottom: 10px;
}

.download-button {
  text-decoration: none;
}

.v-application a {
  color: black;
}

.custom-text {
  color: black !important;
  font-size: 15pt;
}

.no-files {
  margin: auto;
  text-align: center;
  margin-top: 20px;
  color: grey;
}
</style>
